import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button } from "@repo/ui";
import AnimatedCard from "../../../components/AnimatedCard/AnimatedCard";
import PageContainer from "../../../components/PageContainer/PageContainer";
import withAuth from "../../../hoc/withAuth/withAuth";
import { updateThankYouMessage } from "../../../services/giftApiService";
import { useTranslation } from "react-i18next";
import { withTranslations } from "../../../hoc/withTranslations/withTranslations";

const LOCALE = "modules_MyGiftTable_pages_ThankYouMessagePage";

const ThankYouMessagePage: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const { giftId } = useParams<{ giftId: string }>();
  const navigate = useNavigate();
  const [thankYouText, setThankYouText] = useState("");

  const handleSubmit = async () => {
    if (!giftId) return;
    try {
      await updateThankYouMessage(giftId, thankYouText);
      navigate(`/my-table/gift/${giftId}/thankyoumessage/success`);
    } catch (error) {
      console.error(t("updateError"), error);
    }
  };

  return (
    <PageContainer>
      <div className="mt-16"></div>
      <AnimatedCard className="bg-white max-w-lg w-full">
        <h2 className="text-xl font-bold mb-4">{t("heading")}</h2>
        <textarea
          value={thankYouText}
          onChange={(e) => setThankYouText(e.target.value)}
          className="w-full border border-gray-300 p-2 rounded mb-4"
          rows={5}
          placeholder={t("placeholder")}
        />
        <Button type="primary" onClick={handleSubmit} className="w-full">
          {t("send")}
        </Button>
      </AnimatedCard>
    </PageContainer>
  );
};

export default withAuth(withTranslations(LOCALE)(ThankYouMessagePage));
